import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '业务事件',
    type: 'BD_EVENT',
}
